// Mobil ürün kartları için görsel geçişi ve optimize edilmiş dinamik ön yükleme
document.addEventListener('DOMContentLoaded', function() {
  if (!window.matchMedia('(max-width: 999px)').matches) return;

  // 1. Tıklama kontrolü (Event Delegation)
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.mobile-image-nav__btn');
    if (!btn) return;

    e.preventDefault();

    const mediaContainer = btn.closest('.product-item__media');
    if (!mediaContainer || !mediaContainer.querySelector('.product-item__image--two')) return;

    if (btn.classList.contains('mobile-image-nav__btn--next')) {
      mediaContainer.classList.add('is-secondary-shown');
    } else {
      mediaContainer.classList.remove('is-secondary-shown');
    }
  });

  // 2. Akıllı ön yükleme (Intersection & Mutation Observer)
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-preloading');
          // Ürün preload için işaretlendi; tekrar gözlemlemeye gerek yok.
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 150px 0px' 
    });

    // Sadece henüz gözlemlenmeyen ürünleri radara alma fonksiyonu
    const observeProducts = function(elements) {
      elements.forEach(function(container) {
        if (!container.classList.contains('is-observed')) {
          container.classList.add('is-observed');
          imageObserver.observe(container);
        }
      });
    };

    // İlk yüklemede var olan ürünleri seç ve gözlemle
    const initialContainers = document.querySelectorAll('.product-item__media--multiple-images');
    observeProducts(initialContainers);

    // 3. AJAX "Daha Fazla Ürün Göster" Uyumu (Performans Odaklı)
    if ('MutationObserver' in window) {
      const domObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('.product-item__media--multiple-images')) {
                observeProducts([node]);
              }
              if (node.querySelectorAll) {
                const newContainers = node.querySelectorAll('.product-item__media--multiple-images:not(.is-observed)');
                if (newContainers.length > 0) {
                  observeProducts(newContainers);
                }
              }
            }
          });
        });
      });

      domObserver.observe(document.body, { childList: true, subtree: true });
    }

  } else {
    // Eski tarayıcılarda sistemi yormamak için toplu preload iptal edilmiştir.
  }
});